import Axios from 'axios'
import { API_BASE_END_POINT } from '.'
import { getAuthSession, handleAuthResponse, handleAuthError } from './auth-session'

// Instance Configuration

const instance = Axios.create({ baseURL: API_BASE_END_POINT + '/api' })

instance.interceptors.request.use(config => {
	const session = getAuthSession()
	config.authSession = session
	config.headers.common['Authorization'] = session.token ? `Bearer ${session.token}` : ''

	return config
})

instance.interceptors.response.use(handleAuthResponse, handleAuthError)

// Instance Utilities

export const adminHeader = {
	'Admin-Request': 1,
}

export default instance
